import React from "react";

import { Flex, HStack, Stack, StackDirection, Text } from "@chakra-ui/react";

import { CircledDownArrowIcon, CircledUpArrowIcon } from "icons";
import { MobileOnly } from "components/BreakpointVisibility";
import { mobileStyleBreakpoint } from "util/styleHelpers";
import { DEFAULT_EMPTY_VALUE } from "util/statHelpers";

const stackDirection = mobileStyleBreakpoint<string>(
  "column",
  "row"
) as StackDirection;

const LocationsDisplay = ({
  locations,
  type,
}: {
  locations?: SelectOption[];
  type: string;
}): React.ReactElement => {
  if (locations && Array.isArray(locations) && locations.length > 0) {
    return locations.length > 1 ? (
      <HStack spacing={0}>
        <Text
          textStyle="h4"
          color="inherit"
          fontWeight="black"
        >{`Multiple ${type}`}</Text>
        <Text
          as="sup"
          textStyle="ctaSmall"
          color="inherit"
          fontWeight="black"
        >{`+${locations?.length}`}</Text>
      </HStack>
    ) : (
      <Text textStyle="h4" color="inherit" fontWeight="black">
        {locations[0].label}
      </Text>
    );
  } else {
    return (
      <Text textStyle="h4" color="inherit">
        {DEFAULT_EMPTY_VALUE}
      </Text>
    );
  }
};

const TripWidget = ({
  origins,
  destinations,
}: Pick<Contract, "origins" | "destinations">): React.ReactElement => (
  <Stack spacing={0} direction={stackDirection} color="grey.400">
    <HStack spacing={1} mr={8}>
      <CircledUpArrowIcon />
      <LocationsDisplay locations={origins} type="Origins" />
    </HStack>
    <MobileOnly>
      <Flex
        height={5}
        style={{ marginLeft: "8px" }}
        borderLeft="2px dashed"
        borderColor="grey.300"
        width={1}
      />
    </MobileOnly>
    <HStack spacing={1}>
      <CircledDownArrowIcon />
      <LocationsDisplay locations={destinations} type="Destinations" />
    </HStack>
  </Stack>
);

export default TripWidget;
